import { useAccount, useChainId, usePublicClient, useWalletClient } from 'wagmi'
import { useMemo } from 'react'

// Supported chain IDs
export const SUPPORTED_CHAIN_IDS = [61, 63] as const
export type SupportedChainId = (typeof SUPPORTED_CHAIN_IDS)[number]

/**
 * Returns the active web3 context - wagmi version
 * This replaces the old useActiveWeb3React hook
 */
export function useActiveWeb3React() {
  const { address, isConnected } = useAccount()
  const chainId = useChainId()
  const publicClient = usePublicClient()
  const { data: walletClient } = useWalletClient()

  return useMemo(
    () => ({
      account: address,
      chainId: chainId as SupportedChainId | undefined,
      isConnected,
      publicClient,
      walletClient,
      // Legacy compatibility
      active: isConnected,
      library: publicClient,
    }),
    [address, chainId, isConnected, publicClient, walletClient]
  )
}

/**
 * Eager connect is handled automatically by wagmi/RainbowKit
 * This hook is kept for backwards compatibility but does nothing
 */
export function useEagerConnect() {
  // wagmi handles auto-connect via its config
  return true
}

/**
 * Inactive listener is handled automatically by wagmi
 * This hook is kept for backwards compatibility but does nothing
 */
export function useInactiveListener(_suppress = false) {
  // wagmi handles chain/account changes automatically
}
